export default __webpack_public_path__ + "static/media/circle.0e594aaf.png";